import { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import type { Cliente } from '@/types/cliente.model';

interface DeleteClienteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id: string | number) => Promise<void>;
  cliente?: Cliente;
}

const DeleteClienteModal = ({ isOpen, onClose, onDelete, cliente }: DeleteClienteModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!cliente) return;
    
    setIsDeleting(true);
    try {
      await onDelete(cliente.documentId || cliente.id!);
      onClose();
    } catch (error) {
      console.error('Error deleting cliente:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="center"
      backdrop="blur"
      size="md"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-xl font-bold text-red-500">
              Confirmar Eliminación
            </ModalHeader>
            <ModalBody className="py-4">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                  <svg 
                    className="h-6 w-6 text-red-600" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-base font-medium text-gray-900 mb-2">
                    ¿Eliminar cliente "{cliente?.nombre}"?
                  </p>
                  <p className="text-sm text-gray-500">
                    Esta acción eliminará permanentemente este cliente y todos sus datos asociados. 
                    Esta operación no se puede deshacer.
                  </p>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="default" 
                variant="light"
                onPress={onClose}
                disabled={isDeleting}
              >
                Cancelar
              </Button>
              <Button 
                color="danger" 
                onPress={handleDelete}
                isLoading={isDeleting}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteClienteModal;